<app-header></app-header>
<div class="container-fluid bg-contact-us py-24" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <p class="text-center text-5xl font-bold text-white">Enroll</p>
    <p class="pt-8 text-4xl text-center font-bold text-white">Need Assistance? </p>
    <p class="text-2xl text-center text-white pt-4">Contact Us Now!</p>
  </div>
</div>

<div class="container-fluid my-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <img src="assets/images/contact-us.jpg" alt="Contact Us Image" class="max-w-full rounded-2xl">
      </div>
      <div>
        <p class="text-4xl mb-2 font-semibold">Get in touch with Us</p>
        <p class="py-3 text-xl text-justify pe-5 text-zinc-500">
          Welcome to our Admission Management System! We understand the critical importance of efficient and effective
          admissions processes in educational institutions.
        </p>
        <div class="py-4">
          <div class="flex items-center space-x-4 mb-5">
            <div>
              <a href="tel:9310828501">
                <img src="assets/images/call.png" alt="call icon">
              </a>
            </div>
            <div>
              <p class="pb-1 text-xl">Call Us</p>
              <p class="text-zinc-500">9310828501</p>
            </div>
          </div>
          <div class="flex items-center space-x-4 mb-5">
            <div>
              <a href="mailto:support@volmint.com">
                <img src="assets/images/msg.png" alt="email icon">
              </a>
            </div>
            <div>
              <p class=" pb-1 text-xl">E-Mail Us</p>
              <p class="text-zinc-500">support&#64;volmint.com</p>
            </div>
          </div>
          <div class="flex items-center space-x-4 mb-5">
            <div>
              <a
                href="https://www.google.com/maps/dir/28.5999104,77.08672/volmint+google+map/@28.6031852,77.0791628,16z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x390d1bf854143ecb:0x40321da1ddfa8234!2m2!1d77.0809699!2d28.6064602?entry=ttu">
                <img src="assets/images/location.png" alt="location icon">
              </a>
            </div>
            <div>
              <p class="pb-1 text-xl">Location</p>
              <p class="text-zinc-500">29/2, Vijay Enclave, <br>
                Dwarka-Palam Road, Delhi-110045</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 bg-consultancy py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2  ">
      <div class="">
        <div class="w-full flex justify-center md:justify-start">
          <img src="assets/images/Chat.png" alt="Image" class="py-5"/>
        </div>
        <h1 class="font-inter text-white text-3xl font-medium text-center md:text-start">Get a free consultation from our expert</h1>
        <h1 class="font-inter text-white text-5xl font-bold text-center md:text-start"> Right Now!</h1>
        <p class="text-white text-xl pt-3 pb-20 text-center md:text-start">Discover what's possible with Arni University. Let's Innovate, Grow, and Succeed together.</p>
      </div>
      <div class="md:relative lg:relative flex justify-end">
        <div class="bg-white px-8 mt-2 md:mt-20 rounded-lg w-full max-w-lg md:absolute lg:absolute">
          <form class="p-6 flex flex-col gap-4" [formGroup]="addEnquiryForm" (ngSubmit)="submit()">
            <p class="text-center text-2xl font-semibold text-maroon mb-4">Take Control of Your Enrollment Process: Get in Touch With Us Now!</p>
            <div class="flex flex-col gap-4">
              <div class="relative pb-2">
                <label for="name" class="block text-lg font-medium text-gray-700 mb-1">Name</label>
                <input id="name" formControlName="name" type="text" placeholder="John Doe"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('name').hasError('required')">
                  Name field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="email" class="block text-lg font-medium text-gray-700 mb-1">Email</label>
                <input id="email" formControlName="email" type="email" placeholder="abctestmail@gmail.com"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('required')">
                  Email field is required
                </small>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('email').hasError('pattern')">
                  Invalid email format
                </small>
              </div>
              <div class="relative pb-2">
                <label for="contact" class="block text-lg font-medium text-gray-700 mb-1">Phone Number</label>
                <input id="contact" formControlName="contact" type="tel" placeholder="+91-7836899999"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('contact').hasError('required')">
                  Contact field is required
                </small>
              </div>
              <div class="relative pb-2">
                <label for="subject" class="block text-lg font-medium text-gray-700 mb-1">Subject</label>
                <input id="subject" formControlName="subject" type="text" placeholder="Subject"
                       class="block w-full px-4 py-2 border rounded-md border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out"
                       required>
                <small class="absolute text-red-600 text-xs italic mt-1"
                       *ngIf="submitted && addEnquiryForm.get('subject').hasError('required')">
                  Subject field is required
                </small>
              </div>
              <button type="submit"
                      class="table-header-color text-white py-3 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 ease-in-out">
                Get a Call Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container" [style.font-family]="'var(--vex-font)'">
  <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 my-10 ">
    <div class="flex flex-col sm:flex-col md:flex-row lg:flex-row  md:justify-around lg:justify-around  gap-y-10 ">
      <div class="flex flex-row justify-center items-center ">
        <div>
          <img src="../../../../assets/images/Phone-icon.png" alt="Image" class=""/>
        </div>
        <div class="ps-3">
          <p class="font-inter text-lg font-bold">Call Us</p>
          <p>+91 9310828501</p>
        </div>
      </div>
      <div class="flex flex-row justify-center items-center">
        <div>
          <img src="../../../../assets/images/Email.png" alt="Image" class=""/>
        </div>
        <div class="ps-3">
          <p class="font-inter text-lg font-bold">Email Us</p>
          <p>support&#64;volmint.com</p>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</div>

<div class="container mt-10 md:mt-48" [style.font-family]="'var(--vex-font)'">
  <div class="p-5">
    <p class="text-center text-3xl font-medium leading-7">
      Frequently Asked Questions
    </p>
  </div>
  <div class="text-left mt-10px max-w-3xl px-1 md:px-0 mx-auto">
    <mat-accordion class="p-2">
      <mat-expansion-panel class="py-8 md:py-6">
        <mat-expansion-panel-header class="flex items-center">
          <mat-panel-title class="text-lg flex-1">
            <div class="max:w-[15%] min:w-[15%]">
              <mat-icon class="text-maroon text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
            </div>
            <span class="ml-2 max:w-[85%] min:w-[85%]">
        How do I connect with Enroll?
        </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="para-border mt-5 pt-2 text-zinc-500 text-justify">
          You can drop a message on the portal, mail us at support&#64;volmint.com, or call us at +91 9310828501.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion class="p-2">
      <mat-expansion-panel class="py-8 md:py-6">
        <mat-expansion-panel-header>
          <mat-panel-title class="text-lg flex-1">
            <div class="max:w-[15%] min:w-[15%]">
              <mat-icon class="text-maroon text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
            </div>
            <span class="ml-2 max:w-[85%] min:w-[85%]">
        Can we have a consultation?
        </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="para-border mt-5 pt-2 text-zinc-500 text-justify">
          Absolutely, we are encouraging you to get in touch with us and book a free consultation to provide the best
          assistance while choosing our services or products.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion class="p-2">
      <mat-expansion-panel class="py-8 md:py-6">
        <mat-expansion-panel-header>
          <mat-panel-title class="text-lg flex-1">
            <div class="max:w-[15%] min:w-[15%]">
              <mat-icon class="text-maroon text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
            </div>
            <span class="ml-2 max:w-[85%] min:w-[85%]">
        What is the address of Arni University?
        </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="para-border mt-5 pt-2 text-zinc-500 text-justify">
          We would love to have a cup of tea while discussing our services at 29/2, Vijay Enclave, Dwarka-Palam Road,
          Delhi, 110045.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion class="p-2">
      <mat-expansion-panel class="py-8 md:py-6">
        <mat-expansion-panel-header>
          <mat-panel-title class="text-lg flex-1">
            <div class="max:w-[15%] min:w-[15%]">
              <mat-icon class="text-maroon text-2xl h-8 w-8" svgIcon="mat:help_outline"></mat-icon>
            </div>
            <span class="ml-2 max:w-[85%] min:w-[85%]">
         How can I contact your customer support team?
        </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="para-border mt-5 pt-2 text-zinc-500 text-justify">
          Even though you will be assigned a dedicated expert to support you throughout the process, Moreover, you can
          connect with us at +91 9310828501 or mail us at support&#64;volmint.com.
        </p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="above-footer mt-10 py-20" [style.font-family]="'var(--vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <h1 class="mt-5 text-white text-2rem font-medium">
        Enroll: Your Path to Seamless Admissions!
      </h1>
      <p class="mt-4 text-white ">
        Experience powerful admissions management with no commitment.
      </p>
    </div>
  </div>
</div>
<app-footer></app-footer>
